(() => {
  const callback = () => {
    const selectors = {
      navigation: '.navigation-mobile',
      navigationMenu: '.navigation-mobile__menu',
      navigationMenuLink: '.navigation-mobile__menu-link[data-content-id]',
      drawer: '#NavDrawer',
      drawerTitle: '.drawer-menu__header-title',
      drawerBackButton: '.drawer-menu__header-button--back',
      swiper: '.swiper',
      localeSelector: '[data-disclosure-locale]',
      currencySelector: '[data-disclosure-currency]',
    };

    const drawer = document.querySelector(selectors.drawer);
    const drawerTitle = document.querySelector(selectors.drawerTitle);
    const drawerBackButton = document.querySelector(selectors.drawerBackButton);
    const navigation = document.querySelector(selectors.navigation);
    const hasMissingElements = [drawer, drawerTitle, drawerBackButton, navigation].some((element) => !element);
    if (hasMissingElements) return;

    const multiSelectors = [selectors.localeSelector, selectors.currencySelector];
    multiSelectors.forEach((multiSelector) => {
      const element = navigation.querySelector(multiSelector);
      if (element) new theme.Disclosure(element);
    });

    let menuList = [];
    let breadcrumbs = [];

    const navigateToMenu = ({ selectedMenuItem, isForwardDirection = true }) => {
      const getLastBreadcrumb = () => breadcrumbs[breadcrumbs.length - 1] ?? {};

      const updateBreadcrumbs = ({ breadcrumbItem, isForwardDirection }) => {
        isForwardDirection ? breadcrumbs.push(breadcrumbItem) : breadcrumbs.pop();
      };

      const setDrawerTitle = ({ title }) => {
        drawerTitle.innerHTML = title ?? drawerTitle.dataset.initialTitle ?? '';
      };

      if (isForwardDirection) {
        selectedMenuItem.setAttribute('aria-expanded', 'true');

        updateBreadcrumbs({
          breadcrumbItem: {
            linkElement: selectedMenuItem,
            contentId: selectedMenuItem.dataset.contentId,
            title: selectedMenuItem.dataset.title,
          },
          isForwardDirection,
        });
      } else {
        const lastSelectedMenuItem = getLastBreadcrumb();
        lastSelectedMenuItem.linkElement.setAttribute('aria-expanded', 'false');

        updateBreadcrumbs({ isForwardDirection });
      }

      const { contentId, title } = getLastBreadcrumb();
      switchSelectedMenu({ contentId: contentId ?? 'initial', isForwardDirection });
      setDrawerTitle({ title });
    };

    const switchSelectedMenu = ({ contentId, isForwardDirection }) => {
      theme.a11y.removeTrapFocus({
        container: drawer,
        namespace: 'selected_menu_focus',
      });

      menuList.forEach((menu) => {
        const isCurrentlyDisplayed = menu.classList.contains('selected');
        if (isCurrentlyDisplayed) menu.classList.toggle('previous', isForwardDirection);

        const isSelected = menu.dataset.contentId === contentId;
        menu.classList.toggle('selected', isSelected);
        menu.setAttribute('aria-hidden', isSelected ? 'false' : 'true');
      });

      drawerBackButton.setAttribute('aria-hidden', contentId === 'initial' ? 'true' : 'false');

      theme.a11y.trapFocus({
        container: drawer,
        namespace: 'selected_menu_focus',
      });
    };

    const toggleLinkLoader = ({ menuLink }) => {
      const menuLinks = navigation.querySelectorAll(selectors.navigationMenuLink);
      menuLinks.forEach((link) => link.classList.toggle('processing', link === menuLink));
    };

    navigation.addEventListener('click', (event) => {
      const menuLink = event.target.closest(selectors.navigationMenuLink);
      const hasSublevel = !!menuLink?.dataset?.contentId;
      if (!hasSublevel) return;

      event.preventDefault();

      if (!!menuList.length) {
        navigateToMenu({ selectedMenuItem: menuLink });
      } else {
        toggleLinkLoader({ menuLink });
      }
    });

    drawerBackButton.addEventListener('click', () => navigateToMenu({ isForwardDirection: false }));

    const initializeMenus = () => {
      menuList = navigation.querySelectorAll(selectors.navigationMenu);

      const preSelectedLink = navigation.querySelector(`${selectors.navigationMenuLink}.processing`);
      if (preSelectedLink) {
        preSelectedLink.classList.remove('processing');

        setTimeout(() => {
          navigateToMenu({ selectedMenuItem: preSelectedLink });
        }, 100);
      }

      new Swiper(`${selectors.navigationMenu} ${selectors.swiper}`, {
        slidesPerView: 2,
        slidesPerGroup: 1,
        spaceBetween: 10,
        freeMode: {
          enabled: true,
          sticky: true,
        },
        mousewheel: {
          forceToAxis: true,
        },
      });
    };

    document.addEventListener('dynamic-section-rendering:navigation-menu-list-ds:rendered', initializeMenus);
  };

  document.addEventListener('DOMContentLoaded', callback);
})();
